import {
  LOGIN_PAGE,
  MAIN_PAGE,
  MOVE_TO_LOGIN_PAGE,
  MOVE_TO_MAIN_PAGE,
} from "../actions/RouteActions";

const initialState = {
  pageNo: LOGIN_PAGE,
  args: [],
};

export function routeReducer(state = initialState, action) {
  const nextState = Object.assign({}, state);

  switch (action.type) {
    case MOVE_TO_LOGIN_PAGE:
      nextState.pageNo = LOGIN_PAGE;
      return nextState;
    case MOVE_TO_MAIN_PAGE:
      nextState.pageNo = MAIN_PAGE;
      return nextState;
    default:
      return state;
  }
}
